module.exports = __webpack_public_path__ + "img/bg.cc1ae447.png";